const initialState = {
  loading: false,
  loaded: false,
  errors: {},
  data: [],
};

const tasks = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'TASK_LIST_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'TASK_LIST_SUCCESS':
      return {
        ...state,
        loading: false,
        loaded: true,
        data: payload,
      };
    case 'TASK_LIST_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    default:
      return state;
  }
};

export default tasks;


export const taskList = state => state.data;



// WEBPACK FOOTER //
// ./client/app/reducers/tasks.js